/*
 * @Author: wblijinyang
 * @FilePath: /code/mall-fe/src/libs/animate.ts
 * @Description: 动画函数
 */
export const addGoodsAnimate = (event, imgSrc, targetEl) => {
  const { clientX, clientY } = event;
  const bar = document.createElement('div');
  const img = document.createElement('img');
  img.src = imgSrc;
  img.style.width = '40px';
  img.style.height = '40px';
  bar.style.position = 'fixed';
  bar.style.left = '0';
  bar.style.top = `${clientY}px`;
  bar.style.width = '40px';
  bar.style.height = '40px';
  bar.style.borderRadius = '50%';
  bar.style.backgroundColor = '#02b6fd';
  bar.style.backgroundColor = '#000';
  bar.style.zIndex = '9999';
  // transform
  bar.style.transform = `translateX(${clientX}px)`;
  bar.style.transition = 'transform .5s linear, top .5s cubic-bezier(.19,.88,.4,1.35)';
  bar.style.overflow = 'hidden';
  bar.style.boxShadow = '0 2px 5px rgba(0,0,0,.2)';

  bar.appendChild(img);
  document.body.appendChild(bar);
  // 添加动画属性
  setTimeout(() => {
    let targetX = targetEl.getBoundingClientRect().x;
    let targetY = targetEl.getBoundingClientRect().y;
    bar.style.transform = `translateX(${targetX}px)`;
    bar.style.top = `${targetY}px`;
  }, 0);
  /**
   * 动画结束后，删除自己
   */
  bar.ontransitionend = function () {
    this.remove();
  };
};
